import { shallowEqual, useSelector } from "react-redux";

import { AppStoreState } from "../store/RootReducer";

type Props<TResult> = (store: AppStoreState) => TResult;

export function useShallowEqualSelector<TResult = any>(selector: Props<TResult>) {
  return useSelector(selector, shallowEqual);
}
